<template>
  <div id="newScmgoods">
    <div class="btnBoxs">
    <!-- <div>
      <span style="font-size: 0.75rem;">公司名称:</span>
    <el-select v-model="pattern" filterable placeholder="请选择" @change="firm"
               style="width: 245px;" size='mini'>
      <el-option key="index" label="全部" value=""  v-if="companyids == '0'"></el-option>
      <el-option v-for="(item,index) in patternAll" :key="index" :label="item.name" :value="item.GZL_COMPANY_id_PK">
      </el-option>
    </el-select>
    </div> -->
    <div style="margin-right: 50px;">
      <span style="font-size: 0.75rem;">产品名称:</span>
      <el-select v-model="productName" filterable placeholder="请选择"
               style="width: 150px;" size='mini'>
      <el-option v-for="(item,index) in ProductName" :key="index" :label="item" :value="item">
      </el-option>
    </el-select>
    </div>
    <div style="margin-right: 30px;">
      <span style="font-size: 0.75rem;">关键字:</span>
    <el-input v-model="keywords" autocomplete="off" style="width: 150px;" size='mini'>
    </el-input>
    </div>
    <div>
      <el-button type="primary" size='mini'  icon="el-icon-search"   @click="pagefeed(1,scmCompanyid,userName)">搜 索</el-button>
      <el-button  size='mini'  icon="el-icon-circle-close" @click=" keywords = '',productName = ''" v-if="PCshow">清 空</el-button>
    </div>
  </div>
  <div class="block">
    <el-button size='mini' @click="transit" type="success">上 架</el-button>

    </div>
  <el-dialog v-dialogDrag  title="平台销售定价" :visible.sync="dlogTableVisibless" width='70%' @close="close">
    <el-form :model="fromObj" size='small' :inline="true" label-position="left">
      <el-form-item label="平台销售价格:" :label-width="formLabelWidth">
        <el-input v-model="fromObj.platform_price" autocomplete="off"  @blur="platform_price($event)" placeholder="请输入平台销售价格"></el-input>
      </el-form-item>
      <el-form-item label="平台会员销售价格:" :label-width="formLabelWidth">
          <el-input v-model="vip_price" autocomplete="off" placeholder="请输入平台会员销售价格"></el-input>
        </el-form-item>
    </el-form>
    <el-button type="primary" @click="pass()">定 价</el-button>
  </el-dialog>
  <div id="newMemTrial">
    <el-table :data="tableData" border style="width: 100%" fit @selection-change="handleSelectionChange" v-loading="loading"  element-loading-text="拼命加载中" :height="TableHeight">
      <el-table-column type="selection" width="55" align="center">
      </el-table-column>
      <el-table-column prop="LOG_SPOT_SALE_PRODUCT_id_PK" label="id" width="50" align="center">
      </el-table-column>
      <el-table-column prop="name" label="产品名" align="center" show-overflow-tooltip width="180">
      </el-table-column>
      <el-table-column  label="产品图片" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
       <img :src="scope.row.image" alt="">
        </template>
      </el-table-column>
      <el-table-column prop="spec" label="规格" align="center">
      </el-table-column>
      <el-table-column prop="mold" label="品种" align="center">
      </el-table-column>
      <el-table-column prop="platform_price" label="平台价格" align="center" :show-overflow-tooltip="true" width="120">
      </el-table-column>
      <el-table-column prop="vip_price" label="会员价格" align="center" :show-overflow-tooltip="true" width="120">
      </el-table-column>
      <el-table-column prop="factory" label="产地" align="center" :show-overflow-tooltip="true" width="120">
      </el-table-column>
      <el-table-column prop="warehouse" label="仓库" align="center" :show-overflow-tooltip="true" width="120">
      </el-table-column>
      <el-table-column prop="stock" label="库存" align="center" :show-overflow-tooltip="true" width="120">
      </el-table-column>
      <!-- <el-table-column prop="cardid" label="卡号" align="center">
      </el-table-column> -->

      <!-- <el-table-column prop="purchase_price" label="采购价" align="center">
      </el-table-column> -->
      <!-- <el-table-column prop="company_type" label="公司类型" align="center">
      </el-table-column> -->
      <el-table-column prop="allocated" label="已分配库存" align="center" width='100'>
      </el-table-column>
      <el-table-column prop="canstock" label="可用库存" align="center">
      </el-table-column>
      <!-- <el-table-column prop="sale_mode" label="销售状态" align="center" :show-overflow-tooltip="true" width="120">
      </el-table-column> -->
      <el-table-column prop="status" label="审核状态" align="center">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="showDialog(scope.$index, scope.row)">上架</el-button>
          <el-button size="mini" @click="refuse(scope.$index, scope.row)">拒绝</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog v-dialogDrag  title="平台销售定价" :visible.sync="dlogTableVisible" width='70%' @close="close">
      <el-table :data="arr" border style="width: 100%" size='small'>
        <el-table-column prop="LOG_SPOT_SALE_PRODUCT_id_PK" label="id" width="50" align="center">
        </el-table-column>
        <el-table-column prop="name" label="产品名" align="center">
        </el-table-column>
        <el-table-column prop="image" label="产品图片" align="center">
          <template slot-scope="scope">
       <img :src="scope.row.image" alt="">
        </template>
        </el-table-column>
        <el-table-column prop="spec" label="直径" align="center">
        </el-table-column>
        <el-table-column prop="platform_price" label="平台价格" align="center">
      </el-table-column>
      <el-table-column prop="vip_price" label="会员价格" align="center">
      </el-table-column>
        <!-- <el-table-column prop="card_purchase_price" label="采购价" align="center">
        </el-table-column> -->
        <el-table-column prop="mold" label="类型" align="center">
        </el-table-column>
        <el-table-column prop="factory" label="产地" align="center">
        </el-table-column>
        <el-table-column prop="stock" label="库存" align="center">
        </el-table-column>
        <el-table-column prop="entry_user" label="申请人" align="center">
        </el-table-column>
        <!-- <el-table-column prop="purchase_price" label="采购价" align="center">
        </el-table-column> -->
        <el-table-column prop="companyid" label="公司ID" align="center">
        </el-table-column>
      </el-table>
      <el-form :model="fromObj" size='small' :inline="true" label-position="left">
        <el-form-item label="平台销售价格:" :label-width="formLabelWidth">
          <el-input v-model="fromObj.platform_price" autocomplete="off" @blur="platform_price($event)" placeholder="请输入平台销售价格"></el-input>
        </el-form-item>
        <el-form-item label="平台会员销售价格:" :label-width="formLabelWidth">
          <el-input v-model="vip_price" autocomplete="off" placeholder="请输入平台会员销售价格"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="pass()">定 价</el-button>
    </el-dialog>
    <!-- 分页 -->
    <div class="block">
      <el-pagination class="pagination" @current-change="currentChangeHandle" background :current-page="currentPage1"
        :page-size="pageSize" layout="prev, pager, next, slot, jumper" :total="currentPage4">
        <!-- <span style="width: 100px;">
                                <el-input v-model.number="currentPage" @input="handlePageSize" size='mini'></el-input>条/页
                              </span> -->
        <span slot style="width: 40px;color: dimgrey">
          <label><input name="Fruit" type="checkbox" value="" v-model="checked" @change='all' />显示全部</label>
        </span>
      </el-pagination>
    </div>
  </div>
  </div>
</template>

<script>
import {
  companyoption,
  productputaway,
  alterproductsaleprices,
  allocation,
  productname,
  companyproducts 
} from '../../static/API/API.js'
  export default {
    components: { //动态组件
        },
    data() {
      return {
        // 分页
        currentPage4: 0,
        currentPage1: 1,
        currentPage: 10,
        pageSize: 1,
        tableData: [],
        formLabelWidth: '140px',
        dlogTableVisible: false, //模态框隐藏
        dlogTableVisibless: false, //模态框隐藏
        arr: [],
        arr1:[],
        fromObj: {},
         // 是否显示全部
        checked: false,
        vip_price:null,
        keywords:'',
        // 公司名称
        pattern:'0',
        // 公司名称下拉数组
        patternAll:[],
        //pc端小程序显示
        PCshow: true,
        scmCompanyid: '',
        userName: '',
        loading:false,
        TableHeight:490,
        ProductName:[], //牌号
        productName:'',
        companyids:''
      }
    },
    mounted() { //mounted是vue中的一个钩子函数，一般在初始化页面完成后，再对dom节点进行相关操作
      this.companyid = sessionStorage.getItem('companyid')
      this.companyids = sessionStorage.getItem('companyid')
      this.handgetcompanylist()
      this.pagefeed()
      this.getalocation()
      this.getHeight()
      this.getProductNameList()
    },
    created () {
    window.addEventListener('resize', this.getHeight)
  },
    destroyed () {
    window.removeEventListener('resize', this.getHeight)
  },
    methods: { //函数
      // 全局通过
      getHeight(){
    //动态计算表格高度
    this.$nextTick(()=>{
      let windowHeight = document.documentElement.clientHeight || document.bodyclientHeight;
    this.TableHeight = windowHeight - 262;//数值"140"根据需要调整
    })
      },
      transit(){
        if(this.arr.length == 0){
          this.$message({
            message: '请勾选产品！',
            type: 'error',
            duration: 1000,
            showClose: true,
          });
          return
        }
        this.dlogTableVisibless = true
      },
      // 选中数据
      handleSelectionChange(val) {
        this.arr = val
        this.arr1 = val.map(item=>{
          return item.LOG_SPOT_SALE_PRODUCT_id_PK
        })
      },
      // 改变当前所在页
      currentChangeHandle(val) {
        this.currentPage1 = val
        this.pagefeed(1,this.scmCompanyid,this.userName)
      },
        // 监听pageSize文本框的变化，当pageSize为空时，设置pageSize的值为0，以防报错
        all() {
        if (this.checked) {
          this.currentPage = 'all'
          this.pagefeed()
        } else {
          this.currentPage = 10
          this.pagefeed()
        }
      },
      // 监听pageSize文本框的变化，当pageSize为空时，设置pageSize的值为0，以防报错
      handlePageSize() {
        if (!this.pageSize) {
          this.pageSize = 7
          this.pagefeed()
        } else {
          this.pagefeed()
        }
      },
      pagefeed(e, companyid, name) {
        this.loading = true
        let params = new URLSearchParams();
        params.append('ope_type', 'check');
        params.append('page_number', this.currentPage1)
        params.append('page_size', this.currentPage)
        params.append('keyword', this.keywords);
        params.append('name', this.productName);
        this.$axios.get(companyproducts, {
          params
        }).then((res) => {
          console.log(res);
          this.currentPage4 = Number(res.data['page_total'])
          this.tableData = res.data['result']
          setTimeout(() => {
            this.loading = false
          }, 300);
        })
      },
      platform_price(event){
        this.vip_price = ''
        
      },
      //通过
      showDialog(index, row) {
        this.arr1.push(row.LOG_SPOT_SALE_PRODUCT_id_PK)
        this.fromObj = row
        this.vip_price = row.vip_price
        // if(Number(row.platform_price) > 0){
        //   if(Number(row.platform_price) -  this.message < 0){
        //     this.vip_price = Number(row.platform_price)
        //     return
        //   }
        //   this.vip_price = Number(row.platform_price) - this.message
        // }else{
        //   this.vip_price = Number(row.platform_price)
        // }
        this.arr = [row]
        this.dlogTableVisible = true
      },
      getalocation(){
        let params = new URLSearchParams();
        params.append('page_number', 1);
        params.append('page_size', 7);
        params.append('companyid', 0);
        params.append('keyword', '会员价幅度');
        this.$axios.get(allocation, {
          params
        }).then((res) => {
          this.message = res.data[0].pagedata[0].message
        })
      },
      close(){
        this.arr = []
        this.arr1 = []
        // this.fromObj.platform_price = ''
        // this.vip_price = ''
      },
      // 定价
      pass() {
        if(!this.fromObj.platform_price || !this.vip_price){
          this.$message({
            message: '请填写平台销售价格或平台会员价格',
            type: 'error',
            duration: 1000,
            showClose: true,
          });
          return
        }
        if((Number(this.fromObj.platform_price) - Number(this.vip_price)) > 200){
          this.$message({
            type: "error",
            message: '会员价格与平台价格的差价不能超过200元！',
            duration: 1000,
            showClose: true,
          });
          return
      }
      if(Number(this.vip_price) > Number(this.fromObj.platform_price)){
        this.$message({
            type: "error",
            message: '会员价格不能高于平台价格！',
            duration: 1000,
            showClose: true,
          });
          return
      }
      let producData = []
      const confirmText = ['是否确定？'] 
      this.arr && this.arr.forEach((item,index)=>{
      let produc = `产品名称${index+1}：${item.name}、` + `规格为：${item.spec}、` + `平台销售价格为：${this.fromObj.platform_price}元、` + `平台会员价格为：${this.vip_price}元`
      producData.push(produc)
    })
    producData = producData.concat(confirmText)
      const h = this.$createElement
      let newDatas = []
        for (const i in producData) {
          newDatas.push(h('p', null, producData[i]))
        }

      this.$confirm(`当前订单`,
      {
            title: '提示',
            message: h('div', null, newDatas),
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
      }
      )
        .then((_) => {
        //    let arrs = []
        // // 不满足条件处理
        // this.arr.map(item => {
        //   item.status = '已审核'
        //   item.platform_price = this.fromObj.platform_price
        //   if (parseFloat(item.base_price) > parseFloat(item.platform_price)) {
        //     this.$alert('销售价格低于基础价格！', {
        //       confirmButtonText: '确定',
        //       callback: action => {
        //         this.$message({
        //           type: 'info',
        //           message: `销售价格低于基础价格!请修改`,
        //           duration: 1000,
        //           showClose: true,
        //         });
        //       }
        //     });
        //     arrs.push(item)
        //   }
        // })
        // 满足条件
        // if(arrs.length <= 0){
          let params = new URLSearchParams();
          params.append('p_id',this.arr1.join());
          params.append('platform_price', this.fromObj.platform_price)
          params.append('vip_price',this.vip_price)
          this.$axios.post(alterproductsaleprices, params).then(res => {
            if(res.data == 'ok'){
              this.$alert('上架成功!', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
            }else{
              this.$alert(res.data, {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
            }
            this.dlogTableVisible = false
            this.dlogTableVisibless = false
            this.arr1 = []
            this.arr = []
            this.fromObj.platform_price = ''
            this.vip_price = ''
            this.pagefeed()
          });
        // }
        })
        .catch((_) => {});
      },
      refuse(index, row) {
        row.status = '已拒绝'
        let param = new URLSearchParams();
        let params = new URLSearchParams();
        params.append('ope_type', 'update');
        params.append('user_id', sessionStorage.getItem('user_id'))
        params.append('datas', JSON.stringify([row]))
        this.$axios.post(productputaway, params).then(res => {
          if (res.data == 'ok') {
            this.$alert('拒绝成功，请重新修改价格', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
          }else{
            this.$alert(res.data, {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
          }
          this.pagefeed()

        });

      },
      handgetcompanylist(){
        let params = new URLSearchParams();
        this.$axios.get(companyoption, {
          params
        }).then((res) => {
          this.patternAll = res.data
          this.pattern = Number(sessionStorage.getItem('companyid'))

        })
      },
      firm(val) {
        this.scmCompanyid = val
        this.currentPage1 = 1,
        this.currentPage = 7,
        this.pagefeed(1, val, this.userName)
      },
      getProductNameList(){
        let params = new URLSearchParams();
        this.$axios.post(productname, {}).then((res) => {
          this.ProductName = res.data.message
        })
      }
    },
    computed: { //计算属性

    },
    watch: { //监测Vue实例上的数据变动

    }
  }
</script>

<style scoped>
.btnBoxs{
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
/* /deep/ .el-table .el-table__body{
  height: 100%;
} */
</style>



// WEBPACK FOOTER //
// src/views/newMemTrial.vue